import { render, staticRenderFns } from "./CentralEndpoint.vue?vue&type=template&id=c65ba646&"
import script from "./CentralEndpoint.vue?vue&type=script&lang=ts&"
export * from "./CentralEndpoint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports